import { render, staticRenderFns } from "./wikiContents.vue?vue&type=template&id=442b6d74&scoped=true&"
import script from "./wikiContents.vue?vue&type=script&lang=js&"
export * from "./wikiContents.vue?vue&type=script&lang=js&"
import style0 from "./wikiContents.vue?vue&type=style&index=0&id=442b6d74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442b6d74",
  null
  
)

export default component.exports